import api from './../api'
import apiTC from './../apiTC'
import buildQuery from "../../helpers/query/buildQuery"

const baseUrl = ''
export const putInvoiceFile = (payoad) => {
    return api.makeAuthRequest({
        url: `${baseUrl}/invoice-export-requests`,
        method: 'POST',
        data: payoad
    })
}

export const putInvoiceFileTC = (payoad) => {
    return apiTC.makeAuthRequest({
        url: `invoice-export-requests`,
        method: 'POST',
        data: payoad
    })
}

export const downloadTemplate = () => {
    const baseUrl = api.getBaseURL()

    return `${baseUrl}/invoice-export-requests-template-v2.csv`
}

export const downloadTemplateTC = () => {
    const baseUrl = apiTC.getBaseURL()

    return `${baseUrl}/invoice-export-requests-template.csv`
}

export const listRequestInvoice = (params) => {
    const query = buildQuery(params)
    return api.makeAuthRequest({
        url: `${baseUrl}/invoice-export-requests?${query}`,
        method: 'GET'
    })
}

export const listRequestInvoiceTC = (params) => {
    const query = buildQuery(params)
    return apiTC.makeAuthRequest({
        url: `invoice-export-requests?${query}`,
        method: 'GET'
    })
}

export const downloadResult = (requestId) => {
    const baseUrl = api.getBaseURL()

    return `${baseUrl}/invoice-export-result/${requestId}`
}

export const downloadResultTC = (requestId) => {
    const baseUrl = apiTC.getBaseURL()

    return `${baseUrl}/invoice-export-result/${requestId}`
}